/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shy_Dusty_Ant_StepInputs */

const en_shy_dusty_ant_step = /** @type {(inputs: Shy_Dusty_Ant_StepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter mobile phone number...`)
};

const de_shy_dusty_ant_step = /** @type {(inputs: Shy_Dusty_Ant_StepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mobiltelefonnummer eingeben...`)
};

/**
* | output |
* | --- |
* | "Enter mobile phone number..." |
*
* @param {Shy_Dusty_Ant_StepInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const shy_dusty_ant_step = /** @type {((inputs?: Shy_Dusty_Ant_StepInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shy_Dusty_Ant_StepInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shy_dusty_ant_step(inputs)
	return de_shy_dusty_ant_step(inputs)
});